export default __webpack_public_path__ + "static/media/swap-arrow-icon-up.3df4316c.svg";